import React from "react";
import { Navigate, Routes, Route } from "react-router-dom";
import "./App.css";
import AnalyticsPageView from "./components/AnalyticsPageView/AnalyticsPageView";
import AppShell from "./components/AppShell/AppShell";
import PlanPage from "./pages/PlanPage";
import MehrPage from "./pages/MehrPage";
import EntdeckenPage from "./pages/EntdeckenPage";
import ArchivePage from "./pages/ArchivePage";
import AdminOnlyRoute from "./components/AdminOnlyRoute/AdminOnlyRoute";
import SignedInRoute from "./components/SignedInRoute/SignedInRoute";
import LoginPage from "./pages/LoginPage";
import NewsListView from "./components/News/NewsListView";
import ArticleDetailView from "./components/News/ArticleDetailView";
import VerbesserungenPage from "./pages/VerbesserungenPage";
import ActivitiesImportPage from "./pages/ActivitiesImportPage";
import AdminNudgesPage from "./pages/AdminNudgesPage";
import AdminRegionalCalendarsPage from "./pages/AdminRegionalCalendarsPage";
import SchoolInboxPage from "./pages/SchoolInboxPage";
import SchulePage from "./pages/SchulePage";
import BriefingInvitePage from "./pages/BriefingInvitePage";

export default function App() {
  return (
    <>
    <AnalyticsPageView />
    <Routes>
      <Route element={<AppShell />}>
        <Route path="/" element={null} />
        <Route path="/heute" element={<Navigate to="/" replace />} />
        <Route path="/archiv" element={<ArchivePage />} />
        <Route
          path="/plan"
          element={
            <AdminOnlyRoute loginRedirect="/">
              <PlanPage />
            </AdminOnlyRoute>
          }
        />
        <Route
          path="/mehr"
          element={
            <SignedInRoute>
              <MehrPage />
            </SignedInRoute>
          }
        />
        <Route
          path="/entdecken"
          element={
            <AdminOnlyRoute loginRedirect="/">
              <EntdeckenPage />
            </AdminOnlyRoute>
          }
        />
        <Route
          path="/news"
          element={
            <AdminOnlyRoute loginRedirect="/mehr">
              <NewsListView />
            </AdminOnlyRoute>
          }
        />
        <Route
          path="/news/:slug"
          element={
            <AdminOnlyRoute loginRedirect="/mehr">
              <ArticleDetailView />
            </AdminOnlyRoute>
          }
        />
        <Route
          path="/verbesserungen"
          element={
            <SignedInRoute>
              <VerbesserungenPage />
            </SignedInRoute>
          }
        />
        <Route path="/admin/activities-import" element={<ActivitiesImportPage />} />
        <Route path="/admin/gz-sync" element={<ActivitiesImportPage />} />
        <Route path="/schule" element={<SchulePage />} />
        <Route path="/kita" element={<SchulePage />} />
        <Route path="/admin/nudges" element={<AdminNudgesPage />} />
        <Route path="/admin/regional-calendars" element={<AdminRegionalCalendarsPage />} />
        <Route path="/admin/school-inbox" element={<SchoolInboxPage />} />
      </Route>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/einladung/:token" element={<BriefingInvitePage />} />
    </Routes>
    </>
  );
}
